"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAnyAnimation = exports.isAnimation = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

/**
 * Checks if an animation event is named a given name
 * @param event
 * @param animationName
 */
var isAnimation = exports.isAnimation = function isAnimation(event, animationName) {
  return event.animationName.includes(animationName);
};

/**
 * Checks if an animation event is named any of the given names
 * @param event
 * @param animationNames
 */
var isAnyAnimation = exports.isAnyAnimation = function isAnyAnimation(event, animationNames) {
  for (var i = 0, l = animationNames.length; i < l; i++) {
    if (isAnimation(event, animationNames[i])) {
      return true;
    }
  }
  return false;
};